import request from '@/common/request'

// 处方列表-管理员
export const getRecipeListAdmin = (data) => {
  return request.post('/recipe/recipeList/list', data )
}
// 代煎管理-代煎员
export const getRecipeListDecoct = (data) => {
  return request.post('/recipe/recipeDecoct/list', data )
}
// 配药管理-配药员
export const getRecipeListDispense = (data) => {
  return request.post('/recipe/recipeDispense/list', data )
}
// 配送管理-配送员
export const getRecipeListPost = (data) => {
  return request.post('/recipe/recipePost/list', data )
}
// 处方列表-统计
export const getRecipeCount = (params) => {
  return request.get('/recipe/countAll?storeId=1', { params })
}
// 处方药材
export const getRecipeDetail = (params) => {
  return request.get('/recipe/recipeList/detail', { params })
}
// 获取处方详情
export const getRecipeOne = (params) => {
  return request.get('/recipe/recipeList/getOne', { params })
}
// 处方时间轴
export const getRecipeTimeAxis = (params) => {
  return request.get('/recipe/recipeList/timeAxis', { params })
}
// 处方日志
export const getRecipeOptLogs = (params) => {
  return request.get('/recipe/recipeList/optLogs', { params })
}
// 处方配药
export const recipeDispense = (params) => {
  return request.get('/recipe/recipeDispense/dispense', { params })
}
// 处方代煎
export const recipeDecoct = (params) => {
  return request.get('/recipe/recipeDecoct/decoct', { params })
}
// 处方发货
export const recipePost = (params) => {
  return request.get('/recipe/recipePost/post', { params })
}
// 保存处方订单
export const addRecipe = (data) => {
  return request.post('/recipe/add', data )
}
// 取药
export const takeRecipe = (params) => {
  return request.get('/recipe/take', { params })
}
// 医生信息
export const getDoctorInfo = (params) => {
  return request.get('/recipe/recipeList/getDoctorInfo', { params })
}
// 统计---处方列表
export const getRecipeCountAdmin = (params) => {
  return request.get('/recipe/recipeList/count', { params })
}
// 统计---配药列表
export const getRecipeCountDispense = (params) => {
  return request.get('/recipe/recipeDispense/count', { params })
}
// 统计---代煎列表
export const getRecipeCountDecoct = (params) => {
  return request.get('/recipe/recipeDecoct/count', { params })
}
// 统计---配送列表
export const getRecipeCountPost = (params) => {
  return request.get('/recipe/recipePost/count', { params })
}
// 审核列表
export const getAuditPost = (data) => {
  return request.post('/recipe/recipeList/checkList', data )
}
// 审批人列表
export const getAuditor = (params) => {
  return request.get('/vendor/getUserName', { params })
}

// 审厨房审核人列表
export const getauditName = (params) => {
  return request.get('/recipe/recipeList/auditNameList', { params })
}

// 机构列表
export const getlistDoctorHosp = (params) => {
  return request.get('/recipe/recipeList/auditHospNameList', { params })
}
// 审核
export const getAudit = (params) => {
  return request.get('/recipe/recipeList/check', { params })
}
